import React, { Component } from "react"
import { Avatar, Button, Comment, Dropdown, Input, Menu } from "antd"

import threePointsGray from "images/three-points-gray.svg"
import {
  deleteComment,
  createComment,
  getComments,
  editCommentFunc,
} from "./api"
import { LOCAL_USER_ID, LOCAL_USER_PHOTO } from "../../utils/storage"

const { TextArea } = Input

class CommentItem extends Component {
  state = {
    addComment: false,
    editComment: false,
    comment: "",
    commentEdit: "",
    modalActionPlanCreate: false,
  }

  render() {
    const { children, noResponse, initialData } = this.props
    const { addComment, editComment, comment } = this.state
    const sharedData = {
      id_measure: initialData && initialData.id_measure,
      id_division: initialData && initialData.id_division,
      id_dimension: initialData && initialData.id_dimension,
    }

    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => {
            this.setState({
              editComment: true,
              commentEdit: this.props.message,
            })
          }}>
          Editar
        </Menu.Item>
        <Menu.Item
          onClick={async () => {
            await deleteComment({ id_comment: this.props.id_comment })
            const comments = await getComments({ params: sharedData })

            this.props.getDimensions(true)
            this.props.setStateFrom({ comments })
          }}>
          Eliminar
        </Menu.Item>
      </Menu>
    )

    return (
      <Comment
        className="comment-user"
        actions={
          !noResponse && [
            <span
              className="container-actionplan__btn-response"
              onClick={() => this.setState({ addComment: !addComment })}>
              Responder
            </span>,
          ]
        }
        author={
          <React.Fragment>
            <div>
              <span className="container-actionplan__name">
                {this.props.full_name}
              </span>
              <span>- {this.props.position_name}</span>
            </div>
            {parseInt(LOCAL_USER_ID()) === this.props.id_user && (
              <Dropdown overlay={menu}>
                <img src={threePointsGray} alt="tree-points-gray" />
              </Dropdown>
            )}
          </React.Fragment>
        }
        avatar={
          <Avatar src={this.props.profile_picture} alt={this.props.full_name} />
        }
        content={
          editComment ? (
            <div style={{ marginTop: 12 }}>
              <TextArea
                rows={4}
                value={this.state.commentEdit}
                placeholder="Escribe un comentario aquí..."
                onChange={(event) =>
                  this.setState({ commentEdit: event.target.value })
                }
              />
              <div
                className="container-actionplan__add-comment-btns"
                style={{ padding: 0 }}>
                <Button
                  onClick={() =>
                    this.setState({ editComment: false, commentEdit: "" })
                  }>
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  onClick={async () => {
                    await editCommentFunc({
                      id_comment: this.props.id_comment,
                      data: { message: this.state.commentEdit },
                    })

                    const comments = await getComments({ params: sharedData })

                    this.props.setStateFrom({ comments })
                    this.setState({ editComment: false, commentEdit: "" })
                  }}>
                  Editar
                </Button>
              </div>
            </div>
          ) : (
            <p> {this.props.message} </p>
          )
        }>
        {children}

        {!noResponse && addComment && (
          <div className="container-actionplan__add-comment container-actionplan__add-subcomment">
            <Avatar size={64} src={LOCAL_USER_PHOTO()} />
            {/* <TextArea
              rows={4}
              placeholder='Escribe un comentario aquí...'
            /> */}
            <div
              className="container-actionplan__footer"
              style={{ width: "100%", paddingTop: 0 }}>
              <TextArea
                rows={4}
                value={comment}
                onChange={(event) =>
                  this.setState({ comment: event.target.value })
                }
              />
              <div
                className="container-actionplan__add-comment-btns"
                style={{ padding: 0 }}>
                <Button
                  onClick={() =>
                    this.setState({ addComment: false, comment: "" })
                  }>
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  onClick={async () => {
                    await createComment({
                      data: {
                        ...sharedData,
                        id_comment_parent: this.props.id_comment,
                        message: this.state.comment,
                      },
                    })
                    const comments = await getComments({ params: sharedData })

                    this.props.getDimensions(true)
                    this.props.setStateFrom({ comments })
                    this.setState({ addComment: false, comment: "" })
                  }}>
                  Comentar
                </Button>
              </div>
            </div>
          </div>
        )}
      </Comment>
    )
  }
}

export default CommentItem
